// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import BurgerController from "./burger_controller"
application.register("burger", BurgerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import SubmitController from "./submit_controller"
application.register("submit", SubmitController)

import AgentProgressController from "./agent_progress_controller"
application.register("agent-progress", AgentProgressController)

import VariantController from "./variant_controller"
application.register("variant", VariantController)

import BillingPeriodController from "./billing_period_controller"
application.register("billing-period", BillingPeriodController)

import PaywallTrackingController from "./paywall_tracking_controller"
application.register("paywall-tracking", PaywallTrackingController)

import Dialog from "@stimulus-components/dialog"
application.register("dialog", Dialog)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import BlogLanguageController from "./blog_language_controller"
application.register("blog-language", BlogLanguageController)

import CharCountController from "./char_count_controller"
application.register("char-count", CharCountController)

import LinksPanelController from "./links_panel_controller"
application.register("links-panel", LinksPanelController)

import LinkRowsController from "./link_rows_controller"
application.register("link-rows", LinkRowsController)

import RequiredGroupController from "./required_group_controller"
application.register("required-group", RequiredGroupController)

import TimestampOptionsController from "./timestamp_options_controller"
application.register("timestamp-options", TimestampOptionsController)

import YoutubeReportController from "./youtube_report_controller"
application.register("youtube-report", YoutubeReportController)

import TranscriptOutputController from "./transcript_output_controller"
application.register("transcript-output", TranscriptOutputController)

import TagExtractorController from "./tag_extractor_controller"
application.register("tag-extractor", TagExtractorController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import YoutubeEngagementCalculatorController from "./youtube_engagement_calculator_controller"
application.register("youtube-engagement-calculator", YoutubeEngagementCalculatorController)

import YoutubeChannelAgeCheckerController from "./youtube_channel_age_checker_controller"
application.register("youtube-channel-age-checker", YoutubeChannelAgeCheckerController)

import YoutubeTitlePreviewCheckerController from "./youtube_title_preview_checker_controller"
application.register("youtube-title-preview-checker", YoutubeTitlePreviewCheckerController)

import LocaleSwitcherController from "./locale_switcher_controller"
application.register("locale-switcher", LocaleSwitcherController)
